var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "col-12 col-lg-6",
    },
    [
      _c(
        "div",
        {
          staticClass: "card shadow-sm",
        },
        [
          _c(
            "div",
            {
              staticClass: "card-body px-2",
            },
            [
              _c(
                "form",
                {
                  staticClass: "w-100",
                  attrs: {
                    id: "shoot",
                    method: "POST",
                    action: _vm.url,
                  },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.onSubmit.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "flex-width",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "form-group",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.shootValue,
                                    expression: "shootValue",
                                  },
                                ],
                                staticClass:
                                  "form-control text-center text-lg disabled",
                                attrs: {
                                  pattern: "\\d{5,5}",
                                  required: "required",
                                  name: "shoot",
                                  type: "tel",
                                  placeholder: "กรอกเลข 5 หลัก",
                                  maxlength: "5",
                                  min: "5",
                                },
                                domProps: {
                                  value: _vm.shootValue,
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.validateNumber($event)
                                  },
                                  paste: function ($event) {
                                    return _vm.onPaste($event)
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.shootValue = $event.target.value
                                  },
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "flex-width my-1",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-yellow w-100",
                              attrs: {
                                type: "button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.digitClick(1)
                                },
                              },
                            },
                            [_vm._v("\n              1\n            ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "flex-width mx-1 my-1",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-yellow w-100",
                              attrs: {
                                type: "button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.digitClick(2)
                                },
                              },
                            },
                            [_vm._v("\n              2\n            ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "flex-width my-1",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-yellow w-100",
                              attrs: {
                                type: "button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.digitClick(3)
                                },
                              },
                            },
                            [_vm._v("\n              3\n            ")]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "flex-width my-1",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-yellow w-100",
                              attrs: {
                                type: "button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.digitClick(4)
                                },
                              },
                            },
                            [_vm._v("\n              4\n            ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "flex-width mx-1 my-1",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-yellow w-100",
                              attrs: {
                                type: "button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.digitClick(5)
                                },
                              },
                            },
                            [_vm._v("\n              5\n            ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "flex-width my-1",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-yellow w-100",
                              attrs: {
                                type: "button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.digitClick(6)
                                },
                              },
                            },
                            [_vm._v("\n              6\n            ")]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "flex-width my-1",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-yellow w-100",
                              attrs: {
                                type: "button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.digitClick(7)
                                },
                              },
                            },
                            [_vm._v("\n              7\n            ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "flex-width mx-1 my-1",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-yellow w-100",
                              attrs: {
                                type: "button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.digitClick(8)
                                },
                              },
                            },
                            [_vm._v("\n              8\n            ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "flex-width my-1",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-yellow w-100",
                              attrs: {
                                type: "button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.digitClick(9)
                                },
                              },
                            },
                            [_vm._v("\n              9\n            ")]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "flex-width my-1",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-dark w-100",
                              attrs: {
                                type: "reset",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.digitClear()
                                },
                              },
                            },
                            [_vm._v("\n              ลบ\n            ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "flex-width mx-1 my-1",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-yellow w-100",
                              attrs: {
                                type: "button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.digitClick(0)
                                },
                              },
                            },
                            [_vm._v("\n              0\n            ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "flex-width my-1",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-dark w-100",
                              attrs: {
                                type: "button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.digitRandom()
                                },
                              },
                            },
                            [_vm._v("\n              สุ่มเลข\n            ")]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "flex-width my-1",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-primary w-100",
                              attrs: {
                                type: "submit",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.formattedTimeLeft) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }